import React, { useState, useEffect } from "react";
import logo from "../../images/logonew.png";
import defImage from "../../images/PngItem_1503945.png";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { Button } from "bootstrap";
import axios from "axios";
import "bootstrap/dist/js/bootstrap.bundle";
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
const Navbar = ({ pass, username, user }) => {
  const flag = sessionStorage.getItem("loggedIn");
  function buttonClicked() {
    document.querySelector(".navbar-toggler").click();
  }
  const [notLogged, setNotLogged] = useState(true);

  const [scrollPosition, setScrollPosition] = useState(0);
  const [navbarStyle, setNavbarStyle] = useState({
    top: 0,
    backgroundColor: "rgba(255,248,239,0.8)",
  });
  const [opened, setOpened] = useState(false);
  const toQbank = `https://maps-medics.web.app/${username}/${pass}`;
  const loggedIn = "https://maps-medics.web.app/";
  const toLogIn = `/login`;
  // const navbarToggler = document.querySelector('.navbar-toggler');
  // const headerMenu = document.querySelector('.header-menu');

  // navbarToggler.addEventListener('click', function () {
  // headerMenu.classList.toggle('show');
  // navbarToggler.classList.toggle('collapsed');
  // });
  useEffect(() => {
    console.log(pass, username);
    if (sessionStorage.getItem("user_id")) {
      axios
        .get(
          "https://maps-medics-be.onrender.com/check_log/" +
            sessionStorage.getItem("user_id") + "/" + sessionStorage.getItem("token") )
        .then((res) => {
          if (res.data.success === true) {
            setNotLogged(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    window.scrollTo(0, 0);
  }, []);
  async function logOut() {
    let { data } = await axios.get(
      "https://maps-medics-be.onrender.com/user_logout/" +
      sessionStorage.getItem("user_id") +
      "/" +
      sessionStorage.getItem("token")
    );
    console.log("tm l logout b ngah");
    console.log('button clicked')
    sessionStorage.clear();
    sessionStorage.clear();
    window.location.replace("/");
  }
  function toggleNavbar() {
    setOpened(!opened);
  }
  useEffect(() => {
    console.log(sessionStorage.getItem("user_image"));
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      if (scrollPosition > currentScrollPos) {
        setNavbarStyle({
          top: 0,
          backgroundColor: "rgba(255,248,239,0.8)",
        });
      } else {
        setNavbarStyle({
          top: "-300px",
          backgroundColor: "transparent",
        });
      }
      setScrollPosition(currentScrollPos);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPosition]);
  // var prevScrollpos = window.pageYOffset;
  // window.onscroll = function() {
  // var currentScrollPos = window.pageYOffset;
  //   if (prevScrollpos > currentScrollPos) {
  //     document.getElementById("demo").style.top = "0";
  //     document.getElementById("demo").style.backgroundColor='rgba(255,248,239,0.5)'

  //   } else {
  //     document.getElementById("demo").style.top = "-300px";

  //   }

  //   prevScrollpos = currentScrollPos;
  // }
  const defImage = "../../images/PngItem_1503945.png";
  const userImage = sessionStorage.getItem("user_image");

  const imageSrc = userImage == undefined ? defImage : userImage;

  //  <img  alt="User profile image" />

  return (
    <>
      <div className="header-section">
        <div class="header-main">
          <nav
            class=" navbar navbar-expand-lg  header-main-wrapper"
            id="demo"
            style={navbarStyle}
          >
            <div
              class="header-logo"
              style={{ width: "19%", paddingLeft: "1%" }}
            >
              <a href="/">
                <img src={logo} alt="Logo" style={{ cursor: "pointer" }} />
              </a>
            </div>

            <button
              className="navbar-toggler"
              type="button"
              // data-bs-toggle="collapse"
              // data-bs-target="#navbar"
              // aria-expanded="false"
              // aria-label="Toggle navigation"
              onClick={toggleNavbar}

            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className={`header-menu d-lg-block navbar-collapse collapse ${opened ? "show" : ""}`}
              // class="header-menu d-lg-block navbar-collapse collapse"
              id="navbar"
              style={{ justifyContent: "space-around", alignItems: "center" }}
            >
              <ul
                class="nav-menu nav navbar-nav"
                style={{ display: "flex", alignItems: "center" }}
              >
                <li>
                  {" "}
                  <span className="footerlikeNav">
                    <Link
                      to="/"
                      style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Playfair Display",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                      onClick={buttonClicked}
                    >
                      Home
                    </Link>
                  </span>
                </li>
                <li>
                  <span className="footerlikeNav">
                    <Link
                      to="/courses"
                      style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Playfair Display",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                      onClick={buttonClicked}
                    >
                      Courses
                    </Link>
                  </span>
                </li>
                <li>
                  <span className="footerlikeNav">
                  {sessionStorage.getItem("logged_once") ? (
                      <a  style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Playfair Display",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                        onClick={() =>
                          sessionStorage.setItem("logged_toqbank", true)
                        }
                        href={toQbank}
                        // style={{ color: "#fff", textDecoration: "none" }}
                      >
                         QBank
                      </a>
                    ) : (
                      <a
                        href={notLogged === true ? toLogIn : loggedIn}
                        onClick={() => {
                          console.log(sessionStorage.getItem("user_id"));
                        }}
                        style={{
                          textDecoration: "none",
                          color: "#000",
                          fontFamily: "Playfair Display",
                          fontWeight: "700",
                          fontSize: "16px",
                        }}
                        // style={{ color: "#fff", textDecoration: "none" }}
                      >
                        {" "}
                        QBank
                      </a>
                    )}
{/*                   
                    <Link
                      to="/QBankAdver"
                      style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Playfair Display",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                      onClick={buttonClicked}
                    >
                      QBank
                    </Link> */}
                  </span>
                </li>
                <li>
                  <span className="footerlikeNav">
                    <Link
                      to="/blog"
                      style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Playfair Display",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                      onClick={buttonClicked}
                    >
                      Blog
                    </Link>
                  </span>
                </li>
                <li>
                  <span className="footerlikeNav">
                    <Link
                      to="/about"
                      style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Playfair Display",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                      onClick={buttonClicked}
                    >
                      About Us
                    </Link>
                  </span>
                </li>

                <li>
                  <span className="footerlikeNav">
                    <Link
                      to="/contact"
                      style={{
                        textDecoration: "none",
                        color: "#000",
                        fontFamily: "Playfair Display",
                        fontWeight: "700",
                        fontSize: "16px",
                      }}
                      onClick={buttonClicked}
                    >
                      Contact Us
                    </Link>
                  </span>
                </li>
                {/* <li><Link to='/terms'  style={{textDecoration:'none', color:'#000'}} onClick={buttonClicked}>Terms & Conditions</Link></li> */}
              </ul>
              <ul>
                {" "}
                {isMobile && (
                  <li>
                    <div style={{ textAlign: "center" }}>
                      {flag ? (
                        <Link
                          to="/profile"
                          style={{ textDecoration: "none" }}
                          onClick={buttonClicked}
                        >
                          <div style={{ maxWidth: "2vw", borderRadius: "50%" }}>
                            {sessionStorage.getItem("user_image") &&
                              sessionStorage.getItem("user_image") !==
                              undefined ?
                              <>
                                <i class="fa-solid fa-user-doctor fs-3"
                                  style={{ color: "#ffc600" }}></i>
                              </>
                              : <img alt="src" src={sessionStorage.getItem("user_image")} />
                            }

                          </div>
                          {/* {console.log(sessionStorage.getItem("user_image"))} */}
                        </Link>
                      ) : (
                        <Link
                          to="/login"
                          style={{ textDecoration: "none" }}
                          onClick={buttonClicked}
                        >
                          <i
                            class="fa-solid fa-user-doctor fs-3"
                            style={{ color: "#ffc600" }}
                          ></i>

                          {/* <i
                      class="fa-regular fa-user "
                     
                    ></i> */}
                        </Link>
                      )}
                    </div>
                  </li>
                )}
              </ul>

              <ul style={{ alignItems: "center" }}>
                {" "}
                {!isMobile && (
                  <li style={{ padding: "16px 15px" }}>
                    {" "}
                    <div style={{ textAlign: "center" }}>
                      {flag ? (
                        <Link
                          to="/profile"
                          style={{ textDecoration: "none" }}
                          onClick={buttonClicked}
                        >
                          <div style={{ maxWidth: "2vw", borderRadius: "50%" }}>
                            {sessionStorage.getItem("user_image") &&
                              sessionStorage.getItem("user_image") !==
                              "undefined" ? (
                              <img
                                style={{ borderRadius: "50%" }}
                                src={sessionStorage.getItem("user_image")}
                              />
                            ) : (
                              <i
                                class="fa-solid fa-user-doctor fs-3"
                                style={{ color: "#ffc600" }}
                              ></i>
                            )}
                          </div>
                        </Link>
                      ) : (
                        <Link
                          to="/login"
                          style={{ textDecoration: "none" }}
                          onClick={buttonClicked}
                        >
                          <i
                            class="fa-solid fa-user-doctor fs-3"
                            style={{ color: "#ffc600" }}
                          ></i>
                        </Link>
                      )}
                    </div>
                  </li>
                )}
                {flag && (
                  <li style={{ padding: "16px 15px" }}>
                    {" "}
                    <div style={{ maxWidth: "10vw", borderRadius: "50%" }}>
                      {" "}
                      <button
                        className="btn btnHover"
                        onClick={() => {
                          logOut();
                          // sessionStorage.clear();
                          // sessionStorage.clear();
                          // window.location.replace("/");
                        }}
                      >
                        Log out{" "}
                      </button>
                    </div>
                  </li>
                )}
              </ul>
            </div>

            {/* <div class="header-sign-in-up d-none d-lg-block">
                            <ul>
                                <li><a class="sign-in" href="login.html">Sign In</a></li>
                                <li><a class="sign-up" href="register.html">Sign Up</a></li>
                            </ul>
                        </div>
                    */}
            {/* <div class="header-toggle d-lg-none ">
                            <button class="menu-toggle " 
className="navbar-toggler"
type="button"
data-bs-toggle="collapse"
data-bs-target="#navbar"
aria-controls="navbar"
aria-expanded="false"
aria-label="Toggle navigation">
                      <span className="navbar-toggler-icon"></span>

                            </button>
                        </div> */}
          </nav>
        </div>
      </div>
      {/****************************mobile************************** */}
      <div class="mobile-menu ">
        <a class="menu-close">
          <i class="icofont-close-line"></i>
        </a>

        <div class="mobile-top">
          <p>
            <i class="flaticon-phone-call"></i>{" "}
            <a href="tel:9702621413">(970) 262-1413</a>
          </p>
          <p>
            <i class="flaticon-email"></i>{" "}
            <a href="mailto:address@gmail.com">address@gmail.com</a>
          </p>
        </div>

        <div class="mobile-menu-items">
          <ul class="nav-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li>
              <a href="#">All Course</a>
              <ul class="sub-menu">
                <li>
                  <a href="courses.html">Courses</a>
                </li>
                <li>
                  <a href="courses-details.html">Courses Details</a>
                </li>
              </ul>
            </li>

            <li>
              <a href="#">Blog</a>
              <ul class="sub-menu">
                <li>
                  <a href="#">Blog</a>
                </li>
                <li>
                  <a href="#">Blog Details</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="contact.html">Contact</a>
            </li>
          </ul>
        </div>

        <div class="mobile-social">
          <ul class="social">
            <li>
              <a href="#">
                <i class="flaticon-facebook"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i class="flaticon-twitter"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i class="flaticon-skype"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i class="flaticon-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
